import { Link } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { usePageContent, Paragraphs } from "@/lib/usePageContent";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function PolicyPage({ slug, eyebrow, breadcrumb }) {
  const c = usePageContent(slug);
  return (
    <div data-testid={`policy-page-${slug}`}>
      <PageHeader eyebrow={eyebrow} title={c?.title || breadcrumb} subtitle={c?.subtitle} breadcrumb={breadcrumb} />

      <section className="max-w-4xl mx-auto px-6 py-14 text-slate-700 dark:text-slate-300 leading-relaxed">
        <Paragraphs text={c?.body} />
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-16">
        <div className="relative overflow-hidden rounded-2xl bg-primary text-white p-10 text-center">
          <div className="absolute inset-0 hero-grid opacity-40" />
          <div className="relative">
            <h2 className="font-serif font-bold text-2xl sm:text-3xl">Ready to publish with us?</h2>
            <p className="mt-3 text-slate-300">Submit your manuscript and join a global open-access research community.</p>
            <div className="flex flex-wrap justify-center gap-3 mt-6">
              <Button asChild size="lg" className="rounded-full bg-amber-500 hover:bg-amber-600 text-white"><Link to="/submit">Start a Submission <ArrowRight className="w-4 h-4 ml-1" /></Link></Button>
              <Button asChild size="lg" variant="outline" className="rounded-full border-white/30 bg-white/5 text-white hover:bg-white/15"><Link to="/contact">Contact the editors</Link></Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
